import { useState } from 'react';

export const Feedback = (props) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    honeypot: '',
  });
  const [formStatus, setFormStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.honeypot) {
      return;
    }

    setLoading(true);

    const mutation = `
      mutation createGeneralFeedback($name: String!, $email: String!, $message: String!) {
        createGeneralFeedback(name: $name, email: $email, message: $message) {
          success
        }
      }
    `;

    const variables = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    fetch('https://recyclemore-backend.fly.dev/api/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: mutation,
        variables: variables,
      }),
    })
    .then(response => response.json())
    .then(data => {
      setLoading(false);
      setIsSubmitted(true);
      if (data.errors) {
        setFormStatus(props.data ? props.data.errorMessage : 'Something went wrong. Please try again.');
        console.error('Error sending feedback:', data.errors);
      } else {
        setFormStatus(props.data ? props.data.thankYouMessage : 'Thank you for your feedback!');
      }
    })
    .catch(error => {
      setLoading(false);
      setIsSubmitted(true);
      setFormStatus(props.data ? props.data.errorMessage : 'Something went wrong. Please try again.');
      console.error('Error sending feedback:', error);
    });
  };

  return (
    <div id='feedback'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>{props.data ? props.data.title : 'Leave a Feedback'}</h2>
        </div>
        {!isSubmitted ? (
          <form onSubmit={handleSubmit}>
            <div className='row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <input
                    type='text'
                    id='name'
                    name='name'
                    className='form-control'
                    placeholder={props.data ? props.data.namePlaceholder : 'Name'}
                    required
                    onChange={handleChange}
                    value={formData.name}
                  />
                  <p className='help-block text-danger'></p>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    className='form-control'
                    placeholder={props.data ? props.data.emailPlaceholder : 'Email'}
                    required
                    onChange={handleChange}
                    value={formData.email}
                  />
                  <p className='help-block text-danger'></p>
                </div>
              </div>
            </div>
            <div className='form-group'>
              <textarea
                name='message'
                id='message'
                className='form-control'
                rows='4'
                placeholder={props.data ? props.data.messagePlaceholder : 'Message'}
                required
                onChange={handleChange}
                value={formData.message}
              ></textarea>
              <p className='help-block text-danger'></p>
            </div>
            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden='true'>
              <input type='text' name='honeypot' tabIndex='-1' value={formData.honeypot} onChange={handleChange} />
            </div>
            <div id='success'></div>
            <div className='text-center'>
              <button type='submit' className='btn btn-custom btn-lg' disabled={loading}>
                {loading ? (props.data ? props.data.sendingMessage : 'Sending...') : (props.data ? props.data.sendButton : 'Send Message')}
              </button>
            </div>
          </form>
        ) : (
          <p className='text-center'>{formStatus}</p>
        )}
      </div>
    </div>
  );
};